import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { OrgPricingAnalysis, PlanSummary, PricingDetail } from '../models/pricing.types';

@Injectable({
  providedIn: 'root',
})
export class PricingService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  public errorMessage = signal<string | null>(null);

  public planSummaries = signal<PlanSummary[]>([]);
  public orgUsageAnalysis = signal<OrgPricingAnalysis[]>([]);
  public selectedOrgDetail = signal<PricingDetail | null>(null);

  loadPricingAnalysis(startDate: Date, endDate: Date) {
    const params = new HttpParams()
      .set('startDate', startDate.toISOString())
      .set('endDate', endDate.toISOString());

    this.http
      .get<{
        plans: PlanSummary[];
        usage: OrgPricingAnalysis[];
      }>(`${this.apiUrl}/backoffice/pricing/analysis`, { params })
      .subscribe({
        next: (data) => {
          this.planSummaries.set(data.plans);
          this.orgUsageAnalysis.set(data.usage);
        },
        error: (err) => this.errorMessage.set(err.message),
      });
  }

  loadPricingDetail(orgId: number, startDate: Date, endDate: Date) {
    this.selectedOrgDetail.set(null);

    const params = new HttpParams()
      .set('organisationId', orgId.toString())
      .set('startDate', startDate.toISOString())
      .set('endDate', endDate.toISOString());

    this.http.get<PricingDetail>(`${this.apiUrl}/backoffice/pricing/detail`, { params }).subscribe({
      next: (data) => this.selectedOrgDetail.set(data),
      error: (err) => this.errorMessage.set(err.message),
    });
  }
}
